import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Stable identity for client-side editable rows so React keys never fall back to array indexes. */
let _rowSeq = 0;
export function newRowKey() {
  _rowSeq += 1;
  const rnd = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID().slice(0, 8) : Math.random().toString(36).slice(2, 10);
  return `${rnd}-${_rowSeq}`;
}
export const withRowKey = (row) => (row && row._key ? row : { ...row, _key: newRowKey() });

/** Pick one of three values by the sign of `n` — replaces nested "negative ? … : positive ? … : …" ternaries. */
export function bySign(n, { negative, positive, zero }) {
  if (n < 0) return negative;
  if (n > 0) return positive;
  return zero;
}

/** Pick one of three values for a nullable boolean (true / false / not-yet-known). */
export function triState(value, { yes, no, unknown }) {
  if (value === true) return yes;
  if (value === false) return no;
  return unknown;
}

/** Text tone for a signed amount: red below zero, green above, muted at exactly zero. */
export const signTone = (n) => bySign(n, { negative: "text-destructive", positive: "text-success", zero: "text-muted-foreground" });
